module.exports = __webpack_public_path__ + "img/computer-bottom.3db16950.svg";